/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const union_user_join_rank = createAsyncThunk(
  'NewUserJoinGuide/union_user_join_rank',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/chatting/union_user_join_rank',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const follow = createAsyncThunk(
  'NewUserJoinGuide/get_union_recommend_list',
  async (params: any, store: any) => {
    const resp = await http.post('/live/attention/add', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const union_bounty_mission_reward = createAsyncThunk(
  'NewUserJoinGuide/union_bounty_mission_reward',
  async (params: any, store: any) => {
    const {user_id} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/chatting/union_bounty_mission_reward',
      {...params, user_id},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const union_bounty_mission_info = createAsyncThunk(
  'NewUserJoinGuide/union_bounty_mission_info',
  async (params: any, store: any) => {
    const {user_id} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/chatting/union_bounty_mission_info',
      {user_id},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const anchor_call_together_page = createAsyncThunk(
  // 召集信息页面 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174035984
  'NewUserJoinGuide/live/chatting/anchor_call_together_page',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/chatting/anchor_call_together_page',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const anchor_call_together_action = createAsyncThunk(
  // 开启召集与结束召集 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174036012
  'NewUserJoinGuide/live/chatting/anchor_call_together_action',
  async (
    params: {action?: 1 | 2; msg: string; msg_id?: number; room_id: number}, // 用自己编辑的0， 选择的用下标+1
    store: any
  ) => {
    const resp = await http.post(
      '/live/chatting/anchor_call_together_action',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const anchor_active_report_list = createAsyncThunk(
  // 主播活跃报告 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174040189
  'NewUserJoinGuide/live/union/anchor_active_report_list',
  async (params: {union_id?: any; tab_id?: number}, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_active_report_list',
      {
        offset: 0,
        page_size: 1000,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const anchor_welcome_msg_list = createAsyncThunk(
  // 欢迎消息选择列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174035956
  'NewUserJoinGuide/live/union/anchor_welcome_msg_list',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_welcome_msg_list',
      {
        offset: 0,
        page_size: 1000,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const union_leader_send_welcome_msg = createAsyncThunk(
  // 发欢迎消息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174035967
  'NewUserJoinGuide/live/union/union_leader_send_welcome_msg',
  async (params: {union_id: any; mids: any[]; msg: string}, store: any) => {
    const resp = await http.post(
      '/live/union/union_leader_send_welcome_msg',
      {
        offset: 0,
        page_size: 1000,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_union_user_list = createAsyncThunk(
  'NewUserJoinGuide/live/union/get_union_user_list',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_union_user_list',
      {
        tab_id: 0,
        offset: 0,
        limit: 1,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.is_manager
  }
)

interface WorkDetailMember {
  name: string // 成员名称
  mid: number // 成员ID
  avatar: string // 头像链接
  ari_icon?: string // 贵族图标（可选）
  vip_icon?: string // VIP图标（可选）
}
export interface rankItem {
  id: number
  rank: number
  avatar: string
  name: string
  call_count: number // 召唤人数
  join_count: number // 入住人数
  score: number // 总积分
  reward_coins?: number // 赏金 仅主播有该字段
}

export interface rewardType {
  icon: string
  tag?: string
  title: string
  content: string
}

export interface InitialStateType {
  task: any
  activeReport?: Partial<{
    join_count: number // 本月加入人数
    effective_open_count: number // 有效开播数
    get_diamonds_count: number // 获得钻石人数
    diamonds: number // 累计钻石数
    list?: Partial<{
      mid: number // 成员ID
      avatar: string // 头像链接
      name: string // 名称
      vip_icon: string // VIP图标链接
      ari_icon: string // 贵族图标链接
      join_time: string // 加入时间（格式：YYYY-MM-DD HH:mm:ss）
      last_login_time: string // 最后登录时间（格式：YYYY-MM-DD HH:mm:ss）
      diamonds: number // 钻石数量
      recharge_coins: number // 充值 coins 数量
      effective_day: number // 开播天数
    }>[]
  }>
  welcomeMsgList?: string[]
  active: {
    periods?: string[]
    union_list?: rankItem[]
    my_union_rank?: rankItem
    anchor_list?: rankItem[]
    my_anchor_rank?: rankItem
    countdown?: number
    top_union_reward?: rewardType[]
    top_anchor_rewards?: rewardType[][] // 1-3
    tab_id?: number
    chatting_max_coins?: number
    invite_rate?: string
    team_other_rate?: string
    union_id?: number
    team_id?: number
    role?: number
    is_chatting_anchor?: boolean // 是否是承接主播 对应is_active
    is_chatting_union?: boolean // 是否是承接公会 对应is_top
  }
  callPage: Partial<{
    status: 0 | 1 // 召集状态：0=未召集，1=召集中（限定合法值）
    call_count: number // 召集次数
    match_count: number // 本次召集匹配人数
    count_down: number // 进行中倒计时（单位通常为秒，需结合业务场景确认）
    next_call_cd: number // 下一次召集的冷却时间（单位通常为秒，需结合业务场景确认）
    week_coins: number // 本周累计的赏金
    union_rank: number // 公会排行（数值越小排名越靠前）
    call_msgs: string[] // 召集消息列表（数组元素为字符串类型的消息内容）
    chatting_max_coins: number // 承接一个人获得的金币
    top1_coins: number // top1用户额外获得的金币
    call_duration: number
    union_id: number // 公会ID
    level: number
    team_id: number
  }>
  is_manager?: boolean
}

const initialState: InitialStateType = {
  task: {},
  activeReport: {},
  welcomeMsgList: [],
  active: {},
  callPage: {},
  is_manager: false,
}

export const NewUserJoinGuideSlice = createSlice({
  name: 'NewUserJoinGuide',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(union_user_join_rank.fulfilled, (state, action) => {
      Object.assign(state.active, action.payload)
    })
    builder.addCase(union_bounty_mission_info.fulfilled, (state, action) => {
      Object.assign(state.task, action.payload)
    })

    builder.addCase(get_union_user_list.fulfilled, (state, action) => {
      Object.assign(state, {is_manager: action.payload})
    })
    builder.addCase(anchor_call_together_page.fulfilled, (state, action) => {
      Object.assign(state.callPage, action.payload)
    })
    builder.addCase(anchor_active_report_list.fulfilled, (state, action) => {
      Object.assign(state.activeReport, action.payload)
    })
    builder.addCase(anchor_welcome_msg_list.fulfilled, (state, action) => {
      Object.assign(state.welcomeMsgList, action.payload?.list || [])
    })
  },
})
export default NewUserJoinGuideSlice.reducer
export const NewUserJoinGuideActions = NewUserJoinGuideSlice.actions

export const useNewUserJoinGuideState = () =>
  useSelector((store) => store.NewUserJoinGuide) as InitialStateType
